import noUiSlider from 'nouislider';

$(() => {
  const slider = document.getElementById('slider');

  if (getUrlParam('minprice') == null) {
    var minimumprice = parseInt($('.min-therapist-price').data('min-price'));
  } else {
    var minimumprice = parseInt(getUrlParam('minprice'));
  }

  if (getUrlParam('maxprice') == null) {
    var maximumprice = parseInt($('.max-therapist-price').data('max-price'));
  } else {
    var maximumprice = parseInt(getUrlParam('maxprice'));
  }

  noUiSlider.create(slider, {
    start: [minimumprice, maximumprice],
    connect: true,
    behaviour: 'drag',
    step: 5,
    range: {
      min: parseInt($('.min-therapist-price').data('min-price')),
      max: parseInt($('.max-therapist-price').data('max-price'))
    }
  });
  filterTherapistsByPrice();

  slider.noUiSlider.on('update', (values, handle) => {
    filterTherapistsByPrice();
  });

  slider.noUiSlider.on('end', (values, handle) => {
    searchFilterTherapist();
  });
});

function filterTherapistsByPrice() {
  const minprice = parseInt($('.noUi-handle-lower').attr('aria-valuenow'));
  const maxprice = parseInt($('.noUi-handle-upper').attr('aria-valuenow'));

  $('.noUi-handle-lower').attr('data-content', minprice);
  $('.noUi-handle-upper').attr('data-content', maxprice);
}
